/*
 *  File: cancel.component.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from '../services/search.service';
import { Location } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Subscription } from '../models/subscription';
import { CsaService } from '../services/csa.service';
import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/retry';

const url = 'assets/modal.js';

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: []
})
/**
 *
 * @author dlolugu1271
 * @description This component class which is used to 
 * cancel or create a case to customer service.
 * 
 */
export class CancelComponent implements OnInit {

  private tokenStr: any;
  private loading: boolean = true;
  private cancelStatus: any;
  private custName: string = '';
  private custBillEmail: string = '';
  private lineItem: any;
  private retrieveOrderData: any;
  private supportForm: FormGroup;
  private appconfig = environment.appconfig;
  private appextconfig = environment.appextconfig;
  private reasons: any;
  private subs: Subscription;
  private custSerClicked = false;
  private cancelClicked: boolean = false;
  private errorMsg: string;  
  private response: any;
  private commonSysErr: string="";
  private retriveAllResp: any;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private searchService: SearchService,
    private csaService: CsaService,
    private location: Location
  ) { }

  /**
   *
   * @author dlolugu1271
   * @description This method will initialize the data with the subscription
   * details searched in previous page to render in UI.
   * It also initialze the form for customer service.
   * 
   */
  ngOnInit() {
    let subscription = { reason: '-1' }
    this.subs = new Subscription(subscription);
    this.initCustData();
    this.supportForm = new FormGroup({
      firstName: new FormControl('', [
        Validators.required
      ]),
      lastName: new FormControl('', [
        Validators.required
      ]),
      itemKey: new FormControl({ value: ''}, [
        Validators.required,
        Validators.pattern(this.appconfig.search.subsid_pattern)
      ]),
      email: new FormControl({ value: ''}, [
        Validators.required,
        Validators.pattern(this.appconfig.search.email_pattern)
      ]),
      reason: new FormControl('', [
        Validators.required
      ]),
      message: new FormControl('', [
        Validators.required
      ]),
    });
    this.reasons = this.appconfig.cancel_reasons;
  }

  /**
   *
   * @author dlolugu1271
   * @description This method internal to init method.
   * 
   */
  initCustData() {
    this.searchService.cancelResp = null;
    this.csaService.csaResp = null;
    this.retrieveOrderData = JSON.parse(localStorage.getItem('subscription'));
    if (!this.retrieveOrderData) {
      this.router.navigate(['/search'], { relativeTo: this.route });
    }
    let itemKey = localStorage.getItem('itemKey');
    this.subs.itemKey = itemKey;
    this.subs.message = '';
    try {
      if (this.retrieveOrderData.billingCustomer && this.retrieveOrderData.billingCustomer.length > 0) {
        this.subs.firstName = this.retrieveOrderData.billingCustomer[0].firstName
        this.subs.lastName = this.retrieveOrderData.billingCustomer[0].lastName;
        this.custBillEmail = this.retrieveOrderData.billingCustomer[0].email;
      }
      this.custName = this.subs.firstName + ' ' + this.subs.lastName;
      this.subs.email = this.custBillEmail;
      this.lineItem = (this.retrieveOrderData.productLineitems).find(li => li.itemKey === itemKey);
      // check the cancel flag to find the suscription status
      if (this.lineItem.cancelFlag == 'true') {
        this.cancelStatus = this.appconfig.status.cancelled;
      } else if ((this.lineItem.cancelFlag == 'false')) {
        this.cancelStatus = this.appconfig.status.active;
        if (this.lineItem.cancelActivity && this.lineItem.cancelActivity.length > 0) {
          this.cancelStatus = this.appconfig.status.cancel_inprogress;
        }
      }
    } catch (error) {
      this.router.navigate(['/error'], { relativeTo: this.route});
    }
  }

  /** 
   *
   * @author dlolugu1271
   * @description This method will checks the given from
   * control is valid when user enters from UI and returns
   * true if no errors else returns false.
   * @augments field
   * @returns boolean
   * 
   */
  isFieldValid(field: string) {
    if (field == 'reason' && this.supportForm.get(field).value == '-1') {
      return true;
    }
    return !this.supportForm.get(field).valid && (this.supportForm.get(field).touched
      || this.supportForm.get(field).dirty);
  }

  /**
   *
   * @author dlolugu1271
   * @description This method validateAllFormFields validates
   * the form controls.
   * @augments formGroup
   * @returns boolean
   * 
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

   /**
   *
   * @author dlolugu1271
   * @description This method cancelOrder will invoke the
   * search service to perform cancel.
   * 
   */
  cancelOrder() {
    try {
      this.loading = false;
      this.cancelClicked = true;
      this.searchService.cancelOrder(
        this.lineItem.itemKey,
        this.retrieveOrderData.partnerOrderNo,
        this.retrieveOrderData.config.partnerName,
        this.retrieveOrderData.config.clientName,
        this.retrieveOrderData.config.storeName,
        this.retrieveOrderData.config.configId)
       //.timeout(environment.appextconfig.api_timeout_limit)
       // .retry(environment.appextconfig.api_retry_limit)
        .subscribe(
        res => {
          this.response = res;
          if (this.response.hasErrors) {
            this.loading = true;
            this.searchService.cancelResp = { status: 'fail', statusDesc: this.response.statusDesc[0] };
            this.router.navigate(['/cancel-confirm'], { relativeTo: this.route });
          } else {  
            this.searchService.cancelResp = { status: 'success', statusDesc: 'Cancel request sent successfully' };
           setTimeout(() =>  {
              this.recallRetriveAll();
            }, 500);
          }
          
        },
        err => {
          //console.error("***error - cancelOrder***", err);
          this.loading = true;
          this.searchService.cancelResp = { status: 'fail', statusDesc: 'Unable post the cancel request' };
          this.router.navigate(['/cancel-confirm'], { relativeTo: this.route });
        }); 
    } catch (error) {
      this.loading = true;
      this.router.navigate(['/error'], { relativeTo: this.route });
    }
  }
    /**
   *
   * @author dlolugu1271
   * @description This method recallRetriveAll will invoke the
   * search service to retrive subscription details for the cancel/DNR date.
   * 
   */
  recallRetriveAll() {
    //Retrive the subscription details again
    this.searchService.retrieveDeliveryInfo(this.retrieveOrderData.partnerOrderNo,
      this.retrieveOrderData.config.partnerName,
      this.retrieveOrderData.config.clientName, 
      this.retrieveOrderData.config.storeName,
      this.retrieveOrderData.config.configId
      ).subscribe(
        res => {
          if (res == null || res == undefined) {
            this.loading = true;
            this.errorMsg = 'Null response from retriveAll API';
            return;
          }
          this.retriveAllResp = res;
          if (this.retriveAllResp.hasErrors) {
            this.loading = true;
            this.errorMsg = this.retriveAllResp.statusDesc[0];
            return;
          } else {
            let subscription = (this.retriveAllResp.subscriptions).find(item => item.partnerOrderNo === this.retrieveOrderData.partnerOrderNo);
            if (subscription) {
              let cancelLineItem = (subscription.productLineitems).find(li => li.itemKey === localStorage.getItem('itemKey'));
              if (cancelLineItem) {
                if (cancelLineItem.cancelActivity && cancelLineItem.cancelActivity.length > 0) {
                  this.searchService.cancelDate = cancelLineItem.cancelActivity[0].cancelDate;
                  this.loading = true; 
                  this.router.navigate(['/cancel-confirm'], { relativeTo: this.route });
                }
              } else {
                this.loading = true;
                this.errorMsg = 'No Customer details found';
              }
            } else {
              this.loading = true;
              this.errorMsg = 'No Customer details found';
            }
          }
        },
        error => {
          //console.error('**Error - fetchSubsDetails**', error);
          this.loading = true;
          this.router.navigate(['/error'], { relativeTo: this.route });
        }
    );
    if (!this.errorMsg && this.errorMsg != undefined) {
      this.loading = true;
      //console.error('**Error - fetchSubsDetails**', this.errorMsg);
      this.router.navigate(['/error'], { relativeTo: this.route });
    }
}
   /**
   *
   * @author dlolugu1271
   * @description This method callCustService will invoke the
   * csa service to perform case creation to salesforce.
   * 
   */
  callCustService() {
    try {
      this.custSerClicked = true;
      if (!this.supportForm.valid || this.supportForm.controls.reason.value == '-1') {
        this.validateAllFormFields(this.supportForm);
        return;
      }
      this.loading = false;
      this.csaService.csaSubmit(this.supportForm.controls.reason.value,
        this.supportForm.controls.firstName.value,
        this.supportForm.controls.lastName.value,
        this.supportForm.controls.itemKey.value,
        this.supportForm.controls.email.value,
        this.supportForm.controls.message.value).subscribe(
          res => {
            this.loading = true;
            this.csaService.csaResp = { status: 'success', statusDesc: 'created case successfully' };
            this.router.navigate(['/cancel-confirm'], { relativeTo: this.route });
          }, 
          err => {
            //console.error("***error-callCustService***", err);
            this.loading = true;
            //@TODO ignoring the cors issue, so proceeding with success

            /* const JsonParseError = 'Http failure during parsing for';
            const matches = err.message.match(new RegExp(JsonParseError, 'ig'));

            if (err.status && err.status === 200 && matches.length === 1 && err.statusText == 'OK') {
              this.csaService.csaResp = { status: 'success', statusDesc: 'created case successfully' };
            } else {
              this.csaService.csaResp = { status: 'fail', statusDesc: 'Unable post the case' };
            } */
            this.csaService.csaResp = { status: 'success', statusDesc: 'created case successfully' };
            this.router.navigate(['/cancel-confirm'], { relativeTo: this.route });
        });
    } catch (error) {
      //console.error("***error-callCustService catch***", error);
      //handle json failures
      const JsonParseError = 'Http failure during parsing for';
      const matches = error.message.match(new RegExp(JsonParseError, 'ig'));
      if (error instanceof Response) {
        if (error.status === 200 && matches.length === 1 && error.statusText == 'OK') {
          this.csaService.csaResp = { status: 'success', statusDesc: 'created case successfully' };
          this.router.navigate(['/cancel-confirm'], { relativeTo: this.route });
        }
      } else {
        this.router.navigate(['/error'], { relativeTo: this.route });
      }

    }
  }

  /**
   *
   * @author dlolugu1271
   * @description This method loadScript will load the js for
   * rendering the confirmation popup during cancellation.
   * 
   */
  loadScript() {
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  /**
   *
   * @author dlolugu1271
   * @description This method ngAfterViewInit will invoke loadScript
   * to initialze the js in the view.
   * 
   */
  ngAfterViewInit(): void {
    try {
      this.loadScript();
    } catch (error) {
      this.router.navigate(['/error'], { relativeTo: this.route });
    }
  }
}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/cancel/cancel.component.ts